import React from 'react';

interface OptimizedImageProps {
  src: string;
  alt: string;
  className?: string;
  width?: number;
  height?: number;
  preload?: boolean;
  isLCP?: boolean; // Flag for Largest Contentful Paint image
}

export const OptimizedImage: React.FC<OptimizedImageProps> = ({ 
  src, 
  alt, 
  className,
  width = 400,
  height = 300,
  preload = false,
  isLCP = false 
}) => {
  // Convert JPG/PNG paths to WebP if they're local assets
  const isLocalImage = src.startsWith('/');
  let webpSrc = src;
  
  if (isLocalImage && (src.endsWith('.jpg') || src.endsWith('.jpeg') || src.endsWith('.png'))) {
    webpSrc = src.substring(0, src.lastIndexOf('.')) + '.webp';
  }
  
  // Prepare image URL with size parameters for proper sizing
  const sizedSrc = isLocalImage ? `${webpSrc}?w=${width}&h=${height}` : webpSrc;

  return (
    <>
      {/* Preload the LCP image */}
      {isLCP && (
        <link 
          rel="preload" 
          href={sizedSrc} 
          as="image" 
          type="image/webp" 
          fetchpriority="high"
        />
      )}
      
      <picture>
        {isLocalImage && (
          <>
            <source
              srcSet={sizedSrc}
              type="image/webp"
            />
            <source
              srcSet={`${src}?w=${width}&h=${height}`}
              type={src.endsWith('.png') ? "image/png" : "image/jpeg"}
            />
          </>
        )}
        <img
          src={sizedSrc}
          alt={alt}
          className={className}
          width={width}
          height={height}
          loading={isLCP ? "eager" : "lazy"}
          fetchpriority={isLCP ? "high" : "auto"}
        />
      </picture>
    </>
  );
}; 